module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon3.93a5ec0d.svg";